import { useFeatureFlagEnabled } from "posthog-js/react"

import { ALLOW_VEHICLE_CHANGE_FLAG } from "../lib/vehicleChat"

/**
 * Whether a tracked vehicle can be changed after it has been set on a chat.
 *
 * By default a tracked vehicle is assigned once and locked — the field cannot
 * be edited afterwards. When this flag is enabled (per-customer, on the `vhost`
 * person property set in SignIn) the vehicle picker stays editable even if the
 * chat already holds a tracked vehicle.
 */
const useAllowVehicleChange = () => {
  return Boolean(useFeatureFlagEnabled(ALLOW_VEHICLE_CHANGE_FLAG))
}

export default useAllowVehicleChange
